import React from "react"
import { useSearchParams, Link } from "react-router-dom"
import logo from "../asset/images/logo.svg"

const PaymentFailed = () => {
  const [searchParams] = useSearchParams()
  const reason = searchParams.get("reason")
  const postId = searchParams.get("postId")

  const reasonMessages = {
    missing_reference: "Payment reference is missing. Please try again.",
    transaction_not_found: "Transaction not found. Please contact support if payment was deducted.",
    post_not_found: "Request not found. Please try again.",
    transaction_mismatch: "Transaction verification failed. Please contact support.",
    invalid_payment_method: "Invalid payment method used. Only card and bank transfer are allowed.",
    payment_failed: "Payment was not successful. Please try again.",
    server_error: "A server error occurred. Please try again later."
  }

  const message = reasonMessages[reason] || "Payment failed. Please try again."

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <a href="/" className="mb-8 flex items-center justify-center gap-2 text-2xl font-semibold text-gray-900">
            <img className="mr-2 h-8 w-8 -mt-0.5" src={logo} alt="Employ Me logo" />
            <span className="leading-none tracking-tight">Employ Me</span>
          </a>
        </div>

        <div className="rounded-lg border border-gray-200 bg-white p-8 shadow-sm">
          <div className="mb-6 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
              <svg className="h-8 w-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="mb-2 text-2xl font-bold text-gray-900">Payment Failed</h1>
            <p className="text-sm text-gray-600">
              {message}
            </p>
          </div>

          {postId && (
            <div className="mb-6 rounded-lg border border-gray-100 bg-gray-50 p-4">
              <div className="flex justify-between text-sm">
                <span className="font-medium text-gray-600">Request ID:</span>
                <span className="text-gray-900">{postId}</span>
              </div>
            </div>
          )}

          <div className="flex flex-col gap-3">
            {postId ? (
              <Link
                to={`/dashboard/requests/${postId}`}
                className="w-full rounded-lg bg-[#00A5E6] px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-[#008FCC]"
              >
                Try Payment Again
              </Link>
            ) : (
              <Link
                to="/dashboard/requests"
                className="w-full rounded-lg bg-[#00A5E6] px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-[#008FCC]"
              >
                View My Requests
              </Link>
            )}
            <Link
              to="/dashboard"
              className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-center text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentFailed

